import { motion } from 'framer-motion'
import React from 'react'
import { Outlet } from 'react-router'

const PublicRoutes = () => {
  return (<>
    <Outlet/>
        </>
  )
}

export default PublicRoutes